import { Store } from "@tanstack/react-store";
import type React from "react";

// Define the ToastMessage type directly in this file
export type ToastMessage = {
  message: string;
  duration?: number;
  icon?: React.ReactNode;
};

export const errorToastStore = new Store<ToastMessage | undefined>(undefined);

errorToastStore.subscribe(() => {
  console.log("errorToastStore updated");
});

export const setErrorToast = (toast: ToastMessage): boolean => {
  errorToastStore.setState(() => toast);
  return true;
};

export const clearErrorToast = () => {
  errorToastStore.setState(() => undefined);
};
